<ng-container
  *ngIf="
    control?.invalid && (control?.touched || control?.dirty) && firstErrorKey
  "
>
  <div class="gw-text-status-negative">
    <small
      [attr.data-error]="firstErrorKey"
      class="error-message-text"
      [class.error-message-text--stacked]="stacked"
      [class.error-message-text--absolute]="!stacked"
    >
      {{ getMessage(firstErrorKey) }}
    </small>
  </div>
</ng-container>
